import React, { useCallback } from 'react';
import styles from './UploadVideoModal.module.scss';
import Modal from '../Modal';
import UploadClipTab from '../UploadClipTab/UploadClipTab';

const UploadVideoModal = ({ isShow, onClose, loadVideos = () => {}, folderId }) => {
  const handleUploadVideos = useCallback(videos => {
    loadVideos();
    onClose();

    videos.length === 1 && setTimeout(() => {
      if (videos[0].storyId) {
        const url = `${process.env.DOMAIN}/eg/video/${videos[0].storyId}`;
          window.open(url, '_blank');
      }
    }, 500);
  }, []);

  return (
    <Modal open={isShow} onClose={onClose} className={styles.wrapper}>
      <UploadClipTab isVideoUploading={true} onUploadDone={handleUploadVideos} folderId={folderId} />
    </Modal>
  );
};

export default UploadVideoModal;
